import React,{ useState,useEffect} from 'react'
import DataTable from '../Components/Molecules/Table/DataTable'
import { Modal, Button, Form } from 'react-bootstrap';
import _ from "lodash";
import {
  CalendarInput,
  FormDropdown,
  FormField,
  FormFieldMail,
  FormTextArea,
} from "../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../Components/Atoms/Card/Card";
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../Helpers/thousandSeparator";
import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";
import RadioButton from "../Components/Atoms/RadioButton/RadioButton";
import { SingleDatePicker } from "../Components/Atoms/SingleDatePicker/SingleDatePicker";
import styles from "../../src/Pages/Dashboard/Dashboard.module.scss";
import HBar from "../Components/Bars/Bars";
import {add_branch_user_api,branch_list,enquiry_list_url,get_master_data,enquirerToCustomer} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from 'react-router-dom';
import { SubScriptionForm } from './SubScriptionForm';
import LoanApplicationForm from './loanForm/LoanApplicationForm';

export default function EnquiryList() {

  const navigate = useNavigate();
const handleShow = () => setShowModal(true);

const [branchList, setBranchList] = useState([])
const  [selectedRow, setSelectedRow] = useState(null)
const [OpenForm,setOpenForm] = useState(0)
const userData = useSelector((state) => state.auth.user);
const [filterData,setFilterData] = useState({"page":1,"per_page":25,"search_string":"","sort_by":"status_id","sort_order":"asc"}
)

const [showModal, setShowModal] = useState(false);
const handleClose = () => {
  setShowModal(false);
  setSelectedRow(null);
  setSelectedAction("")
  setReloadFun((data)=>{ return {...data,"load":!data.load} });
};

const [serviceTypes,setServiceTypes] = useState([])
const [selectedServiceType, setSelectedServiceType] = useState(null)
const [enquiry_status_list, setEnquiry_status_list] = useState([])
const [subscription_plans, set_subscription_plans] = useState([])
  
const getMasterData = ()=>{
  let postData = {"categories":["md_service_types","md_enquiry_status","md_subscription_plans"]};
  //values["tenant_id"] = _.get(selectedTenant,"id");
   postMethod(get_master_data,postData).then((res)=>{
    

   if(_.get(res,"result.md_subscription_plans.length",0)>0){ 
   let md_service_types =   _.get(res,"result.md_subscription_plans",[]).map((item)=>{
      item["label"] =  item["name"]
      
      return item
    });
    set_subscription_plans(md_service_types)
  }
  if(_.get(res,"result.md_service_types.length",0)>0){ 
    let md_service_types =   _.get(res,"result.md_service_types",[]).map((item)=>{
       item["label"] =  item["name"]
       
       return item
     });
     setServiceTypes(md_service_types)
   }
  if(_.get(res,"result.md_enquiry_status.length",0)>0){ 
    let md_enquiry_status =   _.get(res,"result.md_enquiry_status",[]).map((item)=>{
       item["label"] =  item["name"]
       
       return item
     });
     md_enquiry_status = md_enquiry_status.filter((item)=>item.id !=1)
     setEnquiry_status_list(md_enquiry_status)
   }
    
  })
}
useEffect(()=>{
  getMasterData()
},[])
  const columnDefs = [
    { headerName: "ID", field: "index" ,width: 80},
    { headerName: "TFS Id", field: "tfs_id" ,width: 80},
    { headerName: "Name", field: "name", minWidth:150},
    { headerName: "Email", field: "email",minWidth:150 },
    { headerName: "Phone", field: "mobile_no",minWidth:150 },
    { headerName: "Followup Date", field: "followupdate",minWidth:150 },
    { headerName: "Created Date", field: "created_on",minWidth:150 },
    
    { headerName: "Status", field: "status_details.name",minWidth:150 },
    //{ headerName: "Service", field: "service_details.name",maxWidth:100 },
   
  ];

  columnDefs.push( { headerName: "Actions", field: "actions",maxWidth:10000 },)

  const [isSpinner, setIsSpinner] = useState(false);
  const handleSubmit = (values) => {
    setIsSpinner(true);
    
     values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(add_branch_user_api,values).then((res)=>{
      console.log(res)
      setOpenForm(0)
      setIsSpinner(false);
    }).catch ((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);

    })
  };

  const [selectedTenant, setSelectedTenant ] = useState(()=>{
    if(_.get(userData, "tenant_details",null) !=null){
        return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
     
      
    }else{
      return null
    }
      
  })
  const getBranchList = ()=>{
    let postData = {
      "search_string": "",
      "page": 1,
      "per_page": 100,
      "created_on": "",
      "created_to": "",
      "sort_by": "id",
      "sort_order": "desc",
      "status_ids": []
    }
    postMethod(branch_list,postData).then((res)=>{
      if(_.get(res, "list.length") >0){
        let list = res["list"].map((item)=>{
          item["label"] =  item["name"]
          
          return item
        });
        setBranchList(list);
      }
      
    })

  }
  useEffect(()=>{
    //if(OpenForm ==1 && _.get(userData,"role_id") ==1){
      getBranchList();
    //}
    
  },[OpenForm])

  
 
 let formData = {
  enquiry_status: Yup.string().required("Status is required"),
  service_type: Yup.string().when("enquiry_status", {
    is: "2" ,
    then: (schema) => schema.required("Service Type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  selectedPlan:Yup.string().when("service_type", {
    is:"1",
    then: (schema) => schema.required("Subscription Plan is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  followupdate:Yup.string().when("enquiry_status", {
    is:(val) =>val !="2" ,
    then: (schema) => schema.required("Followup Date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  description:Yup.string().when("enquiry_status", {
    is: (val)=>val !="2" ,
    then: (schema) => schema.required("Description is required"),
    otherwise: (schema) => schema.notRequired(),
  })
  
  
  
}
let initialValues ={
  enquiry_status: "",
  service_type: "",
  selectedPlan:'',
  followupdate:"",
  tenant_id:_.get(selectedTenant,"name","somthing")
  
}
if(_.get(userData,"role_id") ==1){
  formData["tenant_id"] = Yup.string()
  .required("Branch is required")
  //.matches(/^[1-9 + -]+$/, "Only numbers are allowed")
  //initialValues["tenant_id"] = _.get(selectedTenant,"name","somthing")
}

  let formik = useFormik({
    initialValues:initialValues,
    validationSchema: Yup.object(formData),
    onSubmit: handleSubmit,
    validateOnBlur: true,
    validateOnChange: true,
  });

  
  const [selected_status, setSelected_status] = useState(null)
  const [selected_plan, setSelected_plan] = useState(null)

  useEffect(()=>{
    if(OpenForm !=1){
      formik.resetForm();
      setSelectedRow(null)
      setSelected_status(null)
    }
   
  },[OpenForm])

  const [selectedAction, setSelectedAction] = useState(null)
  const [reloadList,setReloadFun] = useState({"load":true})
  const menuActions = (row, type)=>{
    console.log(type)
    setSelectedRow(row);
    setSelectedAction(type);
    
   
  }


  const makeAsCustomer = ()=>{
    
    let errors =false;
    let msg =  {"enquiry_status":"","service_type":"","followupdate":"","description":""}
    if(!_.get(selected_status,"id","")){
      msg["enquiry_status"] = "This field is required"
      errors =true
     }
    
     if([2].indexOf(_.get(selected_status,"id",0)>-1)){
      if(_.get(selectedServiceType,"id",false)){

      
      msg["service_type"] = "This field is required"
      errors =true
    }
     }

     if(!followupdate ){
      msg["followupdate"] = "This field is required"
      errors =true
     }
     if(!_.get(formik,"values.description","")){
     
       msg["description"] = "This field is required"
       errors =true
     }
     
    let postData = {
      "enquiry_id": _.get(selectedRow,"id"),
      "tenant_id": 1
    }
    postData["status_id"] =_.get(selected_status,"id");
    
    if(selected_status["id"] ==2){
       if(selectedServiceType?.id ==1){
        if(selected_plan?.id){
          postData["current_plan_id"] = selected_plan["id"]
        }else{
          console.log("Please select Plan");
        }
        
       }
    }
    if(selected_status?.id !=2  &&  followupdate !="Invalid date"){
      postData["followupdate"] = moment(followupdate).format("YYYY-MM-DD")
    }

    if(selectedServiceType?.id){
      postData["service_type_id"] =selectedServiceType["id"]
    }
    if (postData["status_id"] ==3){
      postData["followupdate"] = moment(followupdate).add(30, "days").format("YYYY-MM-DD")
    }
    postData["description"] = formik.values.description
   
    if(errors){
      setErrorsMessages(msg);
      //return true
    }
    console.log(JSON.stringify(postData))
    
    
    
    setIsSpinner(true);
    postMethod(enquirerToCustomer,postData).then((res)=>{
      
      setIsSpinner(false);
        setSelectedRow(null);
        setSelectedAction("");
        showToast("success",_.get(res, "message","Success"))
        handleClose()
        if(selected_status?.id==2 && _.has(res,"result.loanApplicationId")){
          navigate(`/loan-application-form?loanApplicationId=${res["result"]["loanApplicationId"]}`)

        }
        
        
       }).catch((error)=>{
        
        showToast("error",_.get(error, "message","Something went wrong!"))
        setIsSpinner(false);
  
       })

  }
  useEffect(()=>{
    if(selectedAction=="UPDATE_ENQUIRY" && selectedRow){
        handleShow(true)
    }if (selectedAction =="CREATE_CUSTOMER_FROM_ENQUIRY" && selectedRow){
        handleShow(true)
        
       
    }
  },[selectedAction,showModal])
  
  useEffect(()=>{
    formik.resetForm();
    if(!showModal){
      setSelectedRow(null)
    }
     
      setSelected_status(null)

  },[showModal])

  const [errorsMessages,setErrorsMessages] = useState({"enquiry_status":"","service_type":"","followupdate":"","description":""})
  const [followupdate, setFollowupdate] = useState(null)
  //disabled_btn selected_status == 2 selectedServiceType ==2 setSelected
  const [disabled_btn,setdisabled_btn] =  useState(true);
  const processErrors = ()=>{
    formik.setFieldError("enquiry_status", "This field is required");
    
   let msg =  {"enquiry_status":"","service_type":"","followupdate":"","description":""}
       let error =false  
        if(_.get(selected_status,"id",-1)<=0){
            msg["enquiry_status"] = "This field is required"
            error =true
        }
         if(_.get(selectedServiceType,"id",-1) <=0){
          msg["service_type"] = "This field is required"
          error =true
         }

         if(!followupdate && (_.get(selected_status,"id",-1) !=2)){
          msg["followupdate"] = "This field is required"
          error =true
         }
         if(!_.get(formik,"values.description","")){
         
           msg["description"] = "This field is required"
         }
         if(_.get(selected_status,"id",-1) == 2 ){
            if( _.get(selected_plan,"id",-1) ==1 ){
              msg["selected_plan"] = "This field is required"
              error =true
            }
         }
         setdisabled_btn(error)
         setErrorsMessages({...msg})
       
       //SelectedServiceType ---> service_type
        //followupdate ---> followupdate
       }
  return (
    <div>
       <h3>Enquiry List</h3>
       
        <div className={'mt-3'}>
           {<DataTable reloadList={reloadList} loaded_from="ENQUIRY_LIST" columnDefs={columnDefs} apiUrl={enquiry_list_url} setFilterData={setFilterData} filterData={filterData} editRow={menuActions} showCreateBtn={false} />}
        </div>

       
  
        <Modal size={_.get(selected_status, "id")===2?"xl":'xl'} show={showModal} onHide={() => { handleClose(); setSelectedAction(null); }} centered>
  <Modal.Header closeButton>
    <Modal.Title>Update Status</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form>
      <div class="updateStatusform">
      <div className="row">
     
         <div className="col-md-6 mb-3 123">
          <Form.Group controlId="status">
            <FormDropdown
              id="status"
              name="status"
              label="Status"
              options={enquiry_status_list}
              onChange={(selected) => {
                setSelected_status(selected);
                setSelectedServiceType(null);
                setSelected_plan(null);
                formik.setFieldValue("enquiry_status", selected?.id);
                processErrors()
              }}
              value={formik.values.enquiry_status}
              error={formik.touched.enquiry_status && formik.errors.enquiry_status}
              onBlur={()=>{formik.handleBlur();
                
              }}
            />
            {formik.touched.enquiry_status && (
              <ErrorLabel
                name="enquiry_status"
                formik={formik}
                message={formik.errors.enquiry_status}
              />
            )}
          </Form.Group>
        </div>

        {/*  Service Dropdown (only shown if Status is 2) */}
        {_.get(selected_status, "id") === 2 && (
          <>
          
          <div className="col-md-6 mb-3">
            <Form.Group controlId="service_type">
              <FormDropdown
                id="service_type"
                name="service_type"
                label="Enquiry Type"
                options={serviceTypes}
                onChange={(selected) => {
                  setSelectedServiceType(selected);
                  setSelected_plan(null);
                  formik.setFieldValue("service_type", selected?.id);
                  processErrors()
                }}
                value={formik.values.service_type}
                error={formik.touched.service_type && formik.errors.service_type}
                onBlur={()=>{formik.handleBlur();
                  
                }}
              />
              {formik.touched.service_type && (
                <ErrorLabel
                  name="service_type"
                  formik={formik}
                  message={formik.errors.service_type}
                />
              )}
            </Form.Group>
          </div>
          { _.get(selectedServiceType,"id") ==1 && false && 
          
          <div className="col-md-6 mb-3">
            <Form.Group controlId="service_type">
              <FormDropdown
                id="selectedPlan"
                name="selectedPlan"
                label="Select Plan"
                options={subscription_plans}
                onChange={(selected) => {
                 
                  setSelected_plan(selected);
                  formik.setFieldValue("selectedPlan", selected?.id);
                  
                }}
                value={formik.values.selectedPlan}
                error={formik.touched.selectedPlan && formik.errors.selectedPlan}
                onBlur={()=>{formik.handleBlur();
                  
                }}
              />
              {formik.touched.selectedPlan && (
                <ErrorLabel
                  name="selectedPlan"
                  formik={formik}
                  message={formik.errors.selectedPlan}
                />
              )}
            </Form.Group>
          </div>
        }
        </>


        )}

        {/* Date Picker */
        _.has(selected_status, "id") &&  _.get(selected_status, "id") != 2 && _.get(selected_status, "id") != 3 && <div className="col-md-4 mb-3">
          <Form.Group controlId="followupdate">
            <SingleDatePicker
              selectedDate={formik.values.followupdate}
              onDateChange={(date) =>{
                setFollowupdate(date)
                formik.setFieldValue("followupdate", date)
                processErrors()
              }}
              label="Follow up date"
              placeholder="YYYY/MM/DD"            
              minDate={moment().add(1,"days").format("YYYY/MM/DD")}
              datePickerClass={styles.datePickerClass}
              onBlur={()=>{formik.handleBlur();
               
              }}
            />
          </Form.Group>
          {formik.touched.followupdate && (
            <ErrorLabel
              name="followupdate"
              formik={formik}
              message={errorsMessages["followupdate"]}
            />
          )}
        </div>
        }
        {_.get(selected_status, "id") === 2 && _.get(selectedServiceType, "id") === 1 && <SubScriptionForm loaded_from="ENQUIRY_LIST" details={selectedRow} close_me={()=>handleClose()}/>}
        {_.get(selected_status, "id") === 2 && [2,3,4,5,6,7].indexOf(_.get(selectedServiceType, "id"))>-1 && <LoanApplicationForm loaded_from="ENQUIRY_UPDATE_STATUS" enquiryData={selectedRow} close_me={()=>handleClose()}/>}
      </div>

      {/* Description Field (takes full width) */}
      {(_.get(selected_status, "id") != 2 ) &&<Form.Group controlId="description" className="mb-3">
        <Form.Label>Description</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          name="description"
          value={formik?.values?.description}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={formik.touched.description && formik.errors.description}
        />
       
        {formik.touched.description && (
          <ErrorLabel
            name="description"
            formik={formik}
            message={formik.errors.description}
          />
        )}
        </Form.Group>
      }
      </div>
    </Form>
  </Modal.Body>
  
  {_.get(selected_status, "id") != 2  &&<Modal.Footer>
    <Button variant="secondary" onClick={() => { handleClose(); setSelectedAction(null); }}>
      Close
    </Button>
    <Button disabled={!selected_status?.id} variant="primary" onClick={makeAsCustomer}>
      Update
    </Button>
  </Modal.Footer>
  }
</Modal>


  


    </div>
  )
}
